import { call, fork, put, takeEvery } from 'redux-saga/effects';
import * as ga from '../redux/actions/app';

import {
  GET_SCORE_EXPLAINABLITY,
  getScoreExplainablitySuccess,
  getScoreExplainablityFail,
  getAMLSTMCommonTransactionHistorySuccess,
  getAMLSTMCommonTransactionHistoryFail,
  GET_AMLS_TM_COMMON_TRANSACTION_HISTORY,
  getAMLSTMCommonTransactionTriggeredTypologiesSuccess,
  getAMLSTMCommonTransactionTriggeredTypologiesFail,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES,
  downloadAMLSTMCommonTransactionHistorySuccess,
  downloadAMLSTMCommonTransactionHistoryFail,
  DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY,
  GET_PEER_AND_PROFILE_GRAPH,
  getPeerAndProfileGraphSuccess,
  getPeerAndProfileGraphFail,
  GET_TYPOLOGY_LIST,
  getTypologyListSuccess,
  getTypologyListFail,
  GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID,
  getRiskIndicatorListByTypologyIdSuccess,
  getRiskIndicatorListByTypologyIdFail,
  GET_PREVENTION_SCORE_EXPLAINABLITY,
  getAmlsCommonPreventionScoreExplainablitySuccess,
  getAmlsCommonPreventionScoreExplainablityFail,
  GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS,
  getAMLSTMCommonTransactionTriggeredVariantsSuccess,
  getAMLSTMCommonTransactionTriggeredVariantsFail,
  GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
  getAMLSTMCommonCustomerLoanDetailsSuccess,
  getAMLSTMCommonCustomerLoanDetailsFail,
  DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
  downloadAMLSTMCommonCustomerLoanDetailsFail,
  downloadAMLSTMCommonCustomerLoanDetailsSuccess
} from '../redux/actions/tmCommon';
import * as api from '../services/tmCommon';

const networkLayerObject = new api.NetworkLayer();

function* amlsTMCommonTransactionHistory(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonTransactionHistoryAPI,
      payload
    );

    yield put(getAMLSTMCommonTransactionHistorySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonTransactionHistoryFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionHistory() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_TRANSACTION_HISTORY,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionHistory, payload);
    }
  );
}

function* amlsTMCommonTransactionHistoryDownload(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonDownloadTransactionHistoryAPI,
      payload
    );

    yield put(downloadAMLSTMCommonTransactionHistorySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(downloadAMLSTMCommonTransactionHistoryFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionHistoryDownload() {
  yield takeEvery(
    DOWNLOAD_AMLS_TM_COMMON_TRANSACTION_HISTORY,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionHistoryDownload, payload);
    }
  );
}

function* amlsTMCommonTransactionTriggeredTypologies(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonTransactionTriggeredTypologiesAPI,
      payload
    );

    yield put(getAMLSTMCommonTransactionTriggeredTypologiesSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonTransactionTriggeredTypologiesFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionTriggeredTypologies() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_TYPOLOGIES,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionTriggeredTypologies, payload);
    }
  );
}

function* amlsTMCommonTransactionTriggeredVariants(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonVariantsListForAlertIdAPI,
      payload
    );

    yield put(getAMLSTMCommonTransactionTriggeredVariantsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonTransactionTriggeredVariantsFail({ error }));
  }
}

export function* watchAMLSTMCommonTransactionTriggeredVariants() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_TRANSACTION_TRIGGERED_VARIANTS,
    function* ({ payload }) {
      yield fork(amlsTMCommonTransactionTriggeredVariants, payload);
    }
  );
}

function* amlsTMCommonScoreExplainablity(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonScoreExplainabilityAPI,
      payload
    );
    yield put(getScoreExplainablitySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getScoreExplainablityFail({ error }));
  }
}

export function* watchTMCommonScoreExplainablity() {
  yield takeEvery(GET_SCORE_EXPLAINABLITY, function* ({ payload }) {
    yield fork(amlsTMCommonScoreExplainablity, payload);
  });
}

function* amlsPreventionCommonScoreExplainablity(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.preventionCommonScoreExplainabilityAPI,
      payload
    );
    yield put(getAmlsCommonPreventionScoreExplainablitySuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAmlsCommonPreventionScoreExplainablityFail({ error }));
  }
}

export function* watchPreventionCommonScoreExplainablity() {
  yield takeEvery(GET_PREVENTION_SCORE_EXPLAINABLITY, function* ({ payload }) {
    yield fork(amlsPreventionCommonScoreExplainablity, payload);
  });
}

function* amlsTMCommonPeerAndProfileGraph(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonPeerAndProfileGraphAPI,
      payload
    );
    yield put(getPeerAndProfileGraphSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getPeerAndProfileGraphFail({ error }));
  }
}

export function* watchTMCommonPeerAndProfileGraph() {
  yield takeEvery(GET_PEER_AND_PROFILE_GRAPH, function* ({ payload }) {
    yield fork(amlsTMCommonPeerAndProfileGraph, payload);
  });
}

function* amlsTMCommonTypologyList(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonTypologyListAPI,
      payload
    );
    yield put(getTypologyListSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getTypologyListFail({ error }));
  }
}

export function* watchTMTyplologyList() {
  yield takeEvery(GET_TYPOLOGY_LIST, function* ({ payload }) {
    yield fork(amlsTMCommonTypologyList, payload);
  });
}

function* amlsTMCommonRiskIndicatorList(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.tmCommonRiskIndicatorListAPI,
      payload
    );
    yield put(getRiskIndicatorListByTypologyIdSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getRiskIndicatorListByTypologyIdFail({ error }));
  }
}

export function* watchTMRiskIndicatorList() {
  yield takeEvery(
    GET_RISK_INDICATOR_LIST_BY_TOPOLOGY_ID,
    function* ({ payload }) {
      yield fork(amlsTMCommonRiskIndicatorList, payload);
    }
  );
}

function* amlsTMCommonCustomerLoanDetails(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsTMCommonCustomerLoanDetailsAPI,
      payload
    );
    yield put(getAMLSTMCommonCustomerLoanDetailsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(getAMLSTMCommonCustomerLoanDetailsFail({ error }));
  }
}

export function* watchAMLSTMCommonCustomerLoanDetails() {
  yield takeEvery(
    GET_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
    function* ({ payload }) {
      yield fork(amlsTMCommonCustomerLoanDetails, payload);
    }
  );
}

function* downloadAmlsTMCommonCustomerLoanDetails(payload) {
  try {
    yield put(ga.fetchRequest({ text: 'fetching...' }));
    const response = yield call(
      networkLayerObject.amlsTMCommonCustomerLoanDetailsAPI,
      payload
    );
    yield put(downloadAMLSTMCommonCustomerLoanDetailsSuccess(response));
    yield put(ga.fetchSuccess());
  } catch (error) {
    yield put(ga.fetchFailed({ error: '' }));
    yield put(downloadAMLSTMCommonCustomerLoanDetailsFail({ error }));
  }
}

export function* watchDownloadAMLSTMCommonCustomerLoanDetails() {
  yield takeEvery(
    DOWNLOAD_AMLS_TM_COMMON_CUSTOMER_LOAN_DETAILS,
    function* ({ payload }) {
      yield fork(downloadAmlsTMCommonCustomerLoanDetails, payload);
    }
  );
}
